export class SortHelper{
    static sortByNames(a, b){
        if(a === b){
            return 0;
        }
        return a < b ? -1 : 1;
    }
    
    static sortByCodes(a, b){
        const re = /^(\d+)(\w+)?/;
    
        const matchA = re.exec(a);
        const matchB = re.exec(b);
            
        const aNumPart = matchA && matchA[1] ? parseInt(matchA[1], 10) : 0;
        const bNumPart = matchB && matchB[1] ? parseInt(matchB[1], 10) : 0;
    
        if(aNumPart === bNumPart) {
            const aTextPart = matchA && matchA[2] ? matchA[2] : "";
            const bTextPart = matchB && matchB[2] ? matchB[2] : "";

            if ("" === aTextPart && "" === bTextPart) {
                return a < b ? -1 : 1;
            }

            if(aTextPart === bTextPart){
                return 0;
            }

            return aTextPart < bTextPart ? -1 : 1;
        }
        return aNumPart < bNumPart ? -1 : 1;
    }
    
    static sortLines(sort, a, b) {
        const aValue = a[sort.property];
        const bValue = b[sort.property];
        
        let output = 0;
            
        switch(sort.property){
            case "goName": 
            case "returnName": output = this.sortByNames(aValue, bValue); break;
            case "code":
            case "extCode": output = this.sortByCodes(aValue, bValue); break;
            default: output = this.sortByCodes(aValue, bValue);
        }
    
        return "descending" === sort.type ? output * -1 : output;
    }

    static sort(sort, a, b) {
        const aValue = a[sort.property];
        const bValue = b[sort.property];

        let output = 0;

        switch (sort.property) {
            case "goName":
            case "name":
            case "returnName":
                output = this.sortByNames(aValue, bValue);
                break;

            case "code":
            case "extCode":
                output = this.sortByCodes(aValue, bValue);
                break;

            case "priority":
                output = aValue - bValue;
                break;

            case "orientation":
                const order = { G: 1, R: 2, C: 3 };
                const aOrd = order[aValue] || 99; 
                const bOrd = order[bValue] || 99;
                output = aOrd - bOrd;
                break;

            default:
                output = this.sortByCodes(aValue, bValue);
                break;
        }

        return sort.type === "descending" ? -output : output;
    }

    static defaultLineSorter(a, b){
        const options = {
            property: 'code',
            type: 'ascending'
        }
        return SortHelper.sortLines(options, a, b)
    }

    static defaultPathSorter(a,b) {
        return SortHelper.sortByCodes(a.code, b.code);
    }
}